import type { PostMetadata, PostMetadataGame } from '@/lib/db/types';

type LiveBet = NonNullable<PostMetadata['liveBets']>[number];

const SETTLED_BET_STATUSES = new Set(['won', 'lost', 'pushed']);

export function settledLiveBets(bets: PostMetadata['liveBets'] | undefined): LiveBet[] {
  return (bets || []).filter((b) => SETTLED_BET_STATUSES.has(b.status));
}

export function gamesWithSettlement(games: PostMetadataGame[] | undefined): PostMetadataGame[] {
  return (games || []).filter((g) => g.settlement != null && Object.keys(g.settlement).length > 0);
}
